import Form from './AuditForm'
import schema from './schema'

const LiaForm = { Form, schema }

export default LiaForm
